import React from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import SectionCard from "./SectionCard";

export default function EntityTable({ title, rows = [], columns = [], getRowKey }) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const safeCols = Array.isArray(columns) ? columns : [];

  return (
    <SectionCard title={title} subtitle={`Total: ${safeRows.length}`}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {safeCols.map((c) => (
              <TableCell key={c.key}>
                <Typography sx={{ fontWeight: 900, fontSize: 12 }}>
                  {c.label}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {safeRows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={safeCols.length || 1}>
                <Box sx={{ py: 2 }}>
                  <Typography sx={{ color: "text.secondary", fontSize: 13 }}>
                    No data found.
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            safeRows.map((r, idx) => (
              <TableRow key={getRowKey ? getRowKey(r) : idx}>
                {safeCols.map((c) => (
                  <TableCell key={c.key}>
                    {c.render ? c.render(r) : String(r?.[c.key] ?? "")}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </SectionCard>
  );
}